import { render, staticRenderFns } from "./dataServiceOverView.vue?vue&type=template&id=8f0b52de"
import script from "./dataServiceOverView.vue?vue&type=script&lang=js"
export * from "./dataServiceOverView.vue?vue&type=script&lang=js"
import style0 from "./dataServiceOverView.vue?vue&type=style&index=0&id=8f0b52de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports